import { render, staticRenderFns } from "./ModifyPhone.vue?vue&type=template&id=2894810d&scoped=true&lang=pug&"
import script from "./ModifyPhone.vue?vue&type=script&lang=js&"
export * from "./ModifyPhone.vue?vue&type=script&lang=js&"
import style0 from "./ModifyPhone.vue?vue&type=style&index=0&id=2894810d&scoped=true&lang=scss&"
import style1 from "./ModifyPhone.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2894810d",
  null
  
)

export default component.exports